var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigmoduleframe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "460.57812pt",
    height: "788.17578pt",
    viewBox: "0 0 460.57813 788.17578",
    id: "svg80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 460.39062,787.98828 h -44.40234 m -8.27734,0 h -8.28125 m -8.16016,0 h -8.28125 m -8.27734,0 h -41.28125 m -8.28125,0 h -8.28125 m -8.15625,0 h -8.28125 m -8.28125,0 h -41.28125 m -8.27735,0 h -8.16015 m -8.28125,0 h -8.28125 m -8.27735,0 H 168.3086 m -8.28126,0 h -8.16015 m -8.27735,0 h -8.28124 m -8.28126,0 H 85.749996 m -8.160158,0 h -8.281245 m -8.281252,0 h -8.277345",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 44.468746,787.98831 H 0.18749866 v -43.08203",
    id: "path2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.18749866,736.62891 v -8.16016 m 0,-8.28125 v -8.28125 m 0,-8.27734 v -41.28125 m 0,-8.16016 v -8.28125 m 0,-8.27735 v -8.28124 m 0,-8.28126 v -41.27734 m 0,-8.16016 v -8.28124 m 0,-8.28126 v -8.27734 m 0,-8.28125 v -41.28125 m 0,-8.16016 v -8.27734 m 0,-8.28125 v -8.28125 m 0,-8.16016 v -41.27734 m 0,-8.28125 v -8.28125 m 0,-8.28125 v -8.27735 m 0,-8.16015 v -41.28125 m 0,-8.28125 v -8.27735 m 0,-8.28124 v -8.28125 m 0,-8.16016 v -41.27735 m 0,-8.28124 v -8.28125 m 0,-8.27735 v -8.16016 m 0,-8.28124 v -41.28125 m 0,-8.27735 v -8.28124 m 0,-8.28126 v -8.16015 m 0,-8.27735 V 84.546878 m 0,-8.281252 v -8.277345 m 0,-8.160158 v -8.281245",
    id: "path3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.18749866,43.265626 V 0.18750105 H 44.468746",
    id: "path4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 52.749999,0.18750155 h 8.277344 m 8.28125,0 h 8.28125 m 8.160156,0 h 41.277341 m 8.28126,0 h 8.28124 m 8.27735,0 h 8.16016 m 8.28125,0 h 41.28124 m 8.27735,0 h 8.28125 m 8.28125,0 h 8.16015 m 8.27735,0 h 41.28125 m 8.28125,0 h 8.28125 m 8.15625,0 h 8.28125 m 8.28125,0 h 41.28125 m 8.27734,0 h 8.28126 m 8.16015,0 h 8.28125",
    id: "path5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 415.98828,0.18750105 h 44.40234 V 43.265626",
    id: "path6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 460.39062,51.546876 v 8.28125 m 0,8.160157 v 8.277343 m 0,8.281251 v 41.281253 m 0,8.27734 v 8.16015 m 0,8.28125 v 8.28126 m 0,8.27734 v 41.28125 m 0,8.28125 v 8.16016 m 0,8.27734 v 8.28125 m 0,8.28125 v 41.27734 m 0,8.16016 v 8.28125 m 0,8.28125 v 8.27734 m 0,8.28125 v 41.28125 m 0,8.16016 v 8.27734 m 0,8.28125 v 8.28125 m 0,8.28125 v 41.27735 m 0,8.16015 v 8.28125 m 0,8.28125 v 8.27735 m 0,8.16015 v 41.28125 m 0,8.28125 v 8.27735 m 0,8.28124 v 8.28126 m 0,8.16015 v 41.27735 m 0,8.28124 v 8.28126 m 0,8.27734 v 8.28125 m 0,8.16015 v 41.28126 m 0,8.27734 v 8.28125 m 0,8.28125 v 8.16016",
    id: "path7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 460.39062,744.90628 v 43.08203",
    id: "path8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 460.39062,0.18750055 459.91015,23.585938 V 0.18750055 Z m 0,0",
    id: "path9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 460.39062,0.18750055 V 23.585938 h -0.48047 z m 0,0",
    id: "path10"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,23.226563 -3.48047,0.359375 v -0.359375 z m 0,0",
    id: "path11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,23.226563 v 0.359375 h -3.48047 z m 0,0",
    id: "path12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456.42968,20.226563 -0.35937,3.359375 v -3.359375 z m 0,0",
    id: "path13"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456.42968,20.226563 v 3.359375 h -0.35937 z m 0,0",
    id: "path14"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 444.1875,4.1484386 -3,0.359375 v -0.359375 z m 0,0",
    id: "path15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 444.1875,4.1484386 v 0.359375 h -3 z m 0,0",
    id: "path16"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,0.18750055 -18.72265,0.359376 v -0.359376 z m 0,0",
    id: "path17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,0.18750055 v 0.359376 H 441.1875 Z m 0,0",
    id: "path18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 441.1875,0.18750055 440.82812,4.5078136 V 0.18750055 Z m 0,0",
    id: "path19"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 441.1875,0.18750055 V 4.5078136 h -0.35938 z m 0,0",
    id: "path20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.82813,0.18750155 h 19.5625 M 441.1875,0.5468768 h 18.72266 m 0.48047,-0.35937525 V 23.585939 M 459.91016,0.5468768 V 23.226564 m 0.48047,0.359375 h -4.32032 m 3.83985,-0.359375 h -3.48047 m -0.35938,0.359375 v -3.359375 m 0.35938,3 v -3 M 440.82813,0.18750155 V 4.5078143 m 0.35937,-3.9609375 v 3.6015623 m -0.35937,0.3593752 h 3.35937",
    id: "path21"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 441.1875,4.1484386 h 3 v 0.3593752",
    id: "path22"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 456.42968,20.226563 h -0.35937 M 451.26953,4.5078136 v 1.4374995 m 0,0.3632812 v 1.5585938 m 0,0.3593752 v 1.5624998 m 0,0.4765629 v 1.562499 m 0,0.359376 v 1.558593 m 0,0.359376 v 1.562499",
    id: "path23"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 451.26953,16.027345 v 1.441406",
    id: "path24"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 443.10938,20.347657 h 1.32031 m 0.48047,0 h 1.55859 m 0.35938,0 h 1.5625 m 0.35937,0 h 1.5586 m 0.35937,0 h 1.5625 m 0.48047,0 h 1.55859",
    id: "path25"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.62891,20.347657 h 1.44141",
    id: "path26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 0.18749891,0.18750055 0.55077991,23.585938 V 0.18750055 Z m 0,0",
    id: "path27"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 0.18749891,0.18750055 V 23.585938 h 0.363281 z m 0,0",
    id: "path28"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,23.226563 3.47656199,0.359375 v -0.359375 z m 0,0",
    id: "path29"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,23.226563 v 0.359375 H 4.0273419 Z m 0,0",
    id: "path30"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 4.0273419,20.226563 0.480469,3.359375 v -3.359375 z m 0,0",
    id: "path31"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 4.0273419,20.226563 v 3.359375 h 0.480469 z m 0,0",
    id: "path32"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 16.26953,4.1484386 3,0.359375 v -0.359375 z m 0,0",
    id: "path33"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 16.26953,4.1484386 v 0.359375 h 3 z m 0,0",
    id: "path34"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 0.55077991,0.18750055 19.26953,0.54687655 v -0.359376 z m 0,0",
    id: "path35"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,0.18750055 v 0.359376 H 19.26953 Z m 0,0",
    id: "path36"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 19.26953,0.18750055 19.628905,4.5078136 V 0.18750055 Z m 0,0",
    id: "path37"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 19.26953,0.18750055 V 4.5078136 h 0.359375 z m 0,0",
    id: "path38"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 19.628904,0.18750155 H 0.18749841 M 19.269529,0.5468768 H 0.55077966 M 0.18749841,0.18750155 V 23.585939 M 0.55077966,0.5468768 V 23.226564 M 0.18749841,23.585939 H 4.5078104 M 0.55077966,23.226564 H 4.0273417 m 0.4804687,0.359375 v -3.359375 m -0.4804687,3 v -3 M 19.628904,0.18750155 V 4.5078143 M 19.269529,0.5468768 v 3.6015623 m 0.359375,0.3593752 h -3.359375",
    id: "path39"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19.269533,4.1484386 h -3 v 0.3593752",
    id: "path40"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.0273422,20.226563 H 4.5078107 M 9.3085922,4.5078136 v 1.4374995 m 0,0.3632812 v 1.5585938 m 0,0.3593752 v 1.5624998 m 0,0.4765629 v 1.562499 m 0,0.359376 v 1.558593 m 0,0.359376 v 1.562499",
    id: "path41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9.3085959,16.027345 v 1.441406",
    id: "path42"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 17.468749,20.347657 h -1.441407 m -0.359374,0 h -1.558594 m -0.480469,0 h -1.558593 m -0.359376,0 h -1.562499 m -0.3593756,0 H 8.2304677 m -0.3632813,0 H 6.3085927",
    id: "path43"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 5.8281234,20.347657 H 4.5078084",
    id: "path44"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 460.39062,787.98828 -0.48047,-23.40234 v 23.40234 z m 0,0",
    id: "path45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 460.39062,787.98828 v -23.40234 h -0.48047 z m 0,0",
    id: "path46"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,764.94531 -3.48047,-0.35937 v 0.35937 z m 0,0",
    id: "path47"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,764.94531 v -0.35937 h -3.48047 z m 0,0",
    id: "path48"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456.42968,767.94531 -0.35937,-3.35937 v 3.35937 z m 0,0",
    id: "path49"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 456.42968,767.94531 v -3.35937 h -0.35937 z m 0,0",
    id: "path50"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 444.1875,784.14844 -3,-0.48047 v 0.48047 z m 0,0",
    id: "path51"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 444.1875,784.14844 v -0.48047 h -3 z m 0,0",
    id: "path52"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,787.98828 -18.72265,-0.35937 v 0.35937 z m 0,0",
    id: "path53"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 459.91015,787.98828 v -0.35937 H 441.1875 Z m 0,0",
    id: "path54"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 441.1875,787.98828 -0.35938,-4.32031 v 4.32031 z m 0,0",
    id: "path55"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 441.1875,787.98828 v -4.32031 h -0.35938 z m 0,0",
    id: "path56"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.82813,787.98828 h 19.5625 M 441.1875,787.6289 h 18.72266 m 0.48047,0.35938 v -23.40234 m -0.48047,23.04296 v -22.68359 m 0.48047,-0.35937 h -4.32032 m 3.83985,0.35937 h -3.48047 m -0.35938,-0.35937 v 3.35937 m 0.35938,-3 v 3 m -15.60156,20.04297 v -4.32031 m 0.35937,3.96093 v -3.48046 m -0.35937,-0.48047 h 3.35937",
    id: "path57"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 441.1875,784.14846 h 3 v -0.48053",
    id: "path58"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 456.42968,767.94531 h -0.35937 m -4.80078,15.72266 v -1.44141 m 0,-0.35937 v -1.5586 m 0,-0.36328 v -1.55859 m 0,-0.35938 v -1.55859 m 0,-0.48047 v -1.5625 m 0,-0.35938 v -1.55859",
    id: "path59"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 451.26953,772.14846 v -1.44143",
    id: "path60"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 443.10938,767.82813 h 1.32031 m 0.48047,0 h 1.55859 m 0.35938,0 h 1.5625 m 0.35937,0 h 1.5586 m 0.35937,0 h 1.5625 m 0.48047,0 h 1.55859",
    id: "path61"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.62891,767.82816 h 1.44141",
    id: "path62"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.18749891,787.98828 0.363281,-23.40234 v 23.40234 z m 0,0",
    id: "path63"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.18749891,787.98828 v -23.40234 h 0.363281 z m 0,0",
    id: "path64"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,764.94531 3.47656199,-0.35937 v 0.35937 z m 0,0",
    id: "path65"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,764.94531 v -0.35937 H 4.0273419 Z m 0,0",
    id: "path66"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 4.0273419,767.94531 0.480469,-3.35937 v 3.35937 z m 0,0",
    id: "path67"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 4.0273419,767.94531 v -3.35937 h 0.480469 z m 0,0",
    id: "path68"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 16.26953,784.14844 3,-0.48047 v 0.48047 z m 0,0",
    id: "path69"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 16.26953,784.14844 v -0.48047 h 3 z m 0,0",
    id: "path70"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 0.55077991,787.98828 19.26953,787.62891 v 0.35937 z m 0,0",
    id: "path71"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 0.55077991,787.98828 v -0.35937 H 19.26953 Z m 0,0",
    id: "path72"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 19.26953,787.98828 0.359375,-4.32031 v 4.32031 z m 0,0",
    id: "path73"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 19.26953,787.98828 v -4.32031 h 0.359375 z m 0,0",
    id: "path74"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 19.628904,787.98828 H 0.18749841 M 19.269529,787.6289 H 0.55077966 m -0.36328125,0.35938 V 764.58594 M 0.55077966,787.6289 V 764.94531 M 0.18749841,764.58594 H 4.5078104 m -3.95703074,0.35937 H 4.0273417 m 0.4804687,-0.35937 v 3.35937 m -0.4804687,-3 v 3 m 15.6015623,20.04297 v -4.32031 m -0.359375,3.96093 v -3.48046 m 0.359375,-0.48047 h -3.359375",
    id: "path75"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19.269533,784.14846 h -3 v -0.48053",
    id: "path76"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 4.0273422,767.94531 h 0.4804685 m 4.8007815,15.72266 v -1.44141 m 0,-0.35937 v -1.5586 m 0,-0.36328 v -1.55859 m 0,-0.35938 v -1.55859 m 0,-0.48047 v -1.5625 m 0,-0.35938 v -1.55859",
    id: "path77"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9.3085959,772.14846 v -1.44143",
    id: "path78"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 17.468749,767.82813 h -1.441407 m -0.359374,0 h -1.558594 m -0.480469,0 h -1.558593 m -0.359376,0 h -1.562499 m -0.3593756,0 H 8.2304677 m -0.3632813,0 H 6.3085927",
    id: "path79"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 5.8281234,767.82816 H 4.5078084",
    id: "path80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigmoduleframe);
export default __webpack_public_path__ + "static/media/bigmoduleframe.24432231b53372a9a0f00d4b6fba75d9.svg";
export { ForwardRef as ReactComponent };